import React from 'react';
import ThongTinYeuCauKiemTraDeXuat from './ThongTinYeuCauKiemTraDeXuat.jsx';
import {TextArea} from 'components/tt-forms/common';
import { Link, browserHistory } from 'react-router';
import { GiaiQuyetDonThu } from 'api';
import {ContainerFileDinhKem} from 'components/upload';
import moment from 'moment';
import { ShowIf } from 'components/utils';
import ConfirmDialog from './ConfirmDialog.jsx';
import {
  getParams
} from 'modules/giai-quyet-don/subView/GetParams.jsx';

const loaiTepDinhKem = 'QUYET_DINH';
const loaiQuyTrinh = 'KIEM_TRA_DE_XUAT';

class CanBoKiemTraDeXuat extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      btnLoading: false,
      btnSaveLoading: false,
      openDialog: false,
      openDialogTruongPhongGiaiQuyetDon: false,
      openDialogTruongPhongTTXM: false,
      showAttachFile: false,
      onSave: false,
      id: this.props.id,
      donViId: '',
      yKienGiaiQuyet: '',
      dataGiaiQuyetDon: [],
      thongTinGiaiQuyetDonId: this.props.thongTinGiaiQuyetDonId,
      nextState: 'CAN_BO_CHUYEN_KET_QUA_DON_VI_GIAO',

      taiLieuVanThu: [],
      taiLieuVanThuUpdate: [],
      taiLieuVanThuDelete: [],
      dataFileDinhKem: [],
      dataTaiLieuVanThuDelete: [],
      dataKiemTraDeXuat: this.props.dataKiemTraDeXuat,

      listTaiLieuVanThuShow: [],
      listTaiLieuVanThu: [],
    }
  }

  componentWillMount() {
    this.determinativeVaiTro();
  }

  determinativeVaiTro() {
    let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
    if (typeof userInfo == 'undefined') {
      browserHistory.push('/');
    } else {
      this.setState({
        donViId: userInfo.donViId
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      dataKiemTraDeXuat: nextProps.dataKiemTraDeXuat
    })
    // this.checkFileRequired();
  }

  componentDidMount() {
    this.getThongTinGiaiQuyetDon(this.state.thongTinGiaiQuyetDonId);
    this.checkFileRequired();
    this.setState({
      dataKiemTraDeXuat: this.props.dataKiemTraDeXuat
    })
  }

  checkFileRequired() {
    if(this.props.listTaiLieuVanThuGiaiQuyetDon) {
      let ListTaiLieuVanThu = this.props.listTaiLieuVanThuGiaiQuyetDon.filter(state => {
        return state.nguoiTaoInfo.donViId == this.state.donViId
      });
      let ListTaiLieuVanThuShow = this.props.listTaiLieuVanThuGiaiQuyetDon.filter(state => {
        return state.nguoiTaoInfo.donViId != this.state.donViId
      });

      if (ListTaiLieuVanThuShow.length > 0) {
        this.setState({
          listTaiLieuVanThuShow: ListTaiLieuVanThuShow
        })
      }

      let newArray = [...ListTaiLieuVanThu];
      if (newArray.length == 0) {
        let newItem = {
          ten: 'Báo cáo kết quả KTĐX',
          loaiTepDinhKem: '',
          soQuyetDinh: '',
          ngayQuyetDinh: '',
          tenFile: '',
          duongDan: '',
          progress: 0,
          required: true,
          typeRequired: 'BC_KTDX'
        }
        this.setState({
          listTaiLieuVanThu: [
            ...ListTaiLieuVanThu,
            newItem
          ]
        }, ()=> {
          this.setState({
            showAttachFile: true
          })
        })
      } else {
        let dataCheck = newArray.filter(state => {
          return state.required && state.typeRequired == 'BC_KTDX'
        });
        if (dataCheck.length == 0) {
          let newItem = {
            ten: 'Báo cáo kết quả KTĐX',
            loaiTepDinhKem: '',
            soQuyetDinh: '',
            ngayQuyetDinh: '',
            tenFile: '',
            duongDan: '',
            progress: 0,
            required: true,
            typeRequired: 'BC_KTDX'
          }
          this.setState({
            listTaiLieuVanThu: [
              ...ListTaiLieuVanThu,
              newItem
            ]
          }, ()=> {
            this.setState({
              showAttachFile: true
            })
          })
        } else {
          this.setState({
            listTaiLieuVanThu: ListTaiLieuVanThu
          }, ()=> {
            this.setState({
              showAttachFile: true
            })
          })
        }
      }
    }
  }

  componentWillUnmount() {

  }

  onChange(name, e) {
    this.setState({
      [name]: e.target.value
    });
    this.props.handleChangeData();
  }

  getThongTinGiaiQuyetDon(id) {
    if(typeof this.state.thongTinGiaiQuyetDonId != 'undefined') {
      let params = {
        id: id
      };
      GiaiQuyetDonThu.actions.getThongTinGiaiQuyetDon.request(params).then(res => {
        if(res.data) {
          this.setState({
            dataGiaiQuyetDon: res.data,
            yKienGiaiQuyet: res.data.yKienGiaiQuyet ? res.data.yKienGiaiQuyet : ''
          });
        }
      });
    }
  }

  onClickClose() {
    this.props.handleBack();
  }

  getParams() {
    let dataGiaiQuyetDon = this.state.dataGiaiQuyetDon;
    let params = getParams(dataGiaiQuyetDon, this.state.id);
    return params;
  }

  handleSave(){
    this.setState({
      onSave: true
    }, ()=> {

      this.setState({
        btnLoading: true,
        btnSaveLoading: true
      });
      this.state.dataFileDinhKem.map((item, i) => {
        if (item.taiLieuVanThuId) {
          this.state.taiLieuVanThuUpdate[this.state.taiLieuVanThuUpdate.length] = {
            don: {
              id: Number(this.state.id)
            },
            id: item.taiLieuVanThuId,
            ten: item.ten,
            soQuyetDinh: item.soQuyetDinh,
            ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
            tenFile: item.tenFile,
            duongDan: item.duongDan,
            loaiTepDinhKem: item.loaiTepDinhKem,
            loaiQuyTrinh: item.loaiQuyTrinh,
            required: item.required,
            typeRequired: item.typeRequired ? item.typeRequired : ''
          };
        } else {
          this.state.taiLieuVanThu[this.state.taiLieuVanThu.length] = {
            don: {
              id: Number(this.state.id)
            },
            ten: item.ten,
            soQuyetDinh: item.soQuyetDinh,
            ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
            tenFile: item.tenFile,
            duongDan: item.duongDan,
            loaiTepDinhKem: loaiTepDinhKem,
            loaiQuyTrinh: loaiQuyTrinh,
            required: item.required,
            typeRequired: item.typeRequired ? item.typeRequired : ''
          };
        }
      });

      if (this.state.dataTaiLieuVanThuDelete.length > 0) {
        this.state.dataTaiLieuVanThuDelete.map(item => {
          this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
            id: item
          };
        });
      }

      let params = this.getParams();

      params.yKienGiaiQuyet = this.state.yKienGiaiQuyet;

      this.postTaiLieuVanThu(this.state.taiLieuVanThu, () => {
        this.updateTaiLieuVanThu(this.state.taiLieuVanThuUpdate, () => {
          this.deleteTaiLieuVanThu(this.state.taiLieuVanThuDelete, () => {
            this.props.saveGiaiQuyetDon(params, 'gqdLuu');
          });
        });
      });

    })
  }

  handleGiaiQuyetDon() {
    this.setState({
      onSave: false
    }, ()=> {
      if (this.validateSubmitForm()) {
        this.state.dataFileDinhKem.map((item, i) => {
          if (item.taiLieuVanThuId) {
            this.state.taiLieuVanThuUpdate[this.state.taiLieuVanThuUpdate.length] = {
              don: {
                id: Number(this.state.id)
              },
              id: item.taiLieuVanThuId,
              ten: item.ten,
              soQuyetDinh: item.soQuyetDinh,
              ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
              tenFile: item.tenFile,
              duongDan: item.duongDan,
              loaiTepDinhKem: item.loaiTepDinhKem,
              loaiQuyTrinh: item.loaiQuyTrinh,
              required: item.required,
              typeRequired: item.typeRequired ? item.typeRequired : ''
            };
          } else {
            this.state.taiLieuVanThu[this.state.taiLieuVanThu.length] = {
              don: {
                id: Number(this.state.id)
              },
              ten: item.ten,
              soQuyetDinh: item.soQuyetDinh,
              ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
              tenFile: item.tenFile,
              duongDan: item.duongDan,
              loaiTepDinhKem: loaiTepDinhKem,
              loaiQuyTrinh: loaiQuyTrinh,
              required: item.required,
              typeRequired: item.typeRequired ? item.typeRequired : ''
            };
          }
        });

        if (this.state.dataTaiLieuVanThuDelete.length > 0) {
          this.state.dataTaiLieuVanThuDelete.map(item => {
            this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
              id: item
            };
          });
        }
        let params = {};
        if (this.props.tuGiaiQuyet) {
          params = {
            thongTinGiaiQuyetDon: {
              id: Number(this.props.thongTinGiaiQuyetDonId)
            },
            yKienGiaiQuyet: this.state.yKienGiaiQuyet,
            actionType: 'TU_KTDX'
          }
        } else {
          let selectedState = this.props.dataNextStates.filter(state => {
            return state.type == this.state.nextState
          });

          params = {
            thongTinGiaiQuyetDon: {
              id: Number(this.state.thongTinGiaiQuyetDonId)
            },
            nextState: {
              id: Number(selectedState[0].stateId)
            },
            yKienGiaiQuyet: this.state.yKienGiaiQuyet
          }
        }
        this.postTaiLieuVanThu(this.state.taiLieuVanThu, () => {
          this.updateTaiLieuVanThu(this.state.taiLieuVanThuUpdate, () => {
            this.deleteTaiLieuVanThu(this.state.taiLieuVanThuDelete, () => {
              this.props.postGiaiQuyetDon(params, 'ktdxTraBaoCao');
            });
          });
        });
      }
    })
  }

  onFileChange(data) {
    this.setState ({
      dataFileDinhKem: data
    });
    this.props.handleChangeData();
  }

  // Cap nhat tep dinh kem
  updateTaiLieuVanThu(fileList, callback) {
    if (fileList && fileList.length) {
      let params = {
        taiLieuVanThus: fileList
      };
      GiaiQuyetDonThu.actions.updateTaiLieuDinhKem.request('', params).then(res => {
        callback();
      }).catch(error => {
        if (error.response) {
        }
        callback();
      });
    } else {
      callback();
    }
  }

  // Them tep dinh kem
  postTaiLieuVanThu(fileList, callback) {
    if (fileList && fileList.length) {
      let params = {
        taiLieuVanThus: fileList
      };
      GiaiQuyetDonThu.actions.postTaiLieuDinhKem.request('', params).then(res => {
        callback();
      }).catch(error => {
        if (error.response) {
        }
        callback();
      });
    } else {
      callback();
    }
  }

  // Xoa tep dinh kem
  deleteTaiLieuVanThu(fileList, callback) {
    if (fileList && fileList.length) {
      let params = {
        taiLieuVanThus: fileList
      };
      GiaiQuyetDonThu.actions.deleteTaiLieuDinhKem.request('', params).then(res => {
        callback();
      }).catch(error => {
        if (error.response) {
        }
        callback();
      });
    } else {
      callback();
    }
  }

  onFileRemove(id, data) {
    this.setState({
      dataTaiLieuVanThuDelete: [
        ...this.state.dataTaiLieuVanThuDelete,
        id
      ],
      dataFileDinhKem: data
    });
    this.props.handleChangeData();

  }

  validateSubmitForm() {
    let pass = true;
    this.props.validators['formTaoDon'].map(validator => {
      if(pass) {
        pass = validator.validate();
      } else {
        validator.validate();
      }
    });
    return pass;
  }

  openDialog(name) {
    if (this.validateSubmitForm()) {
      this.setState({
        openDialog: true
      })
    }
  }

  closeDialog() {
    this.setState({
      openDialog: false
    })
  }

  onSuccess(name) {
    this.setState({
      openDialog: false
    });
    this.handleGiaiQuyetDon();
  }

  render() {
    let lb1 = this.props.donInfo && this.props.donInfo.loaiDon == 'DON_KIEN_NGHI_PHAN_ANH' ? 'Xác nhận giao xác minh đề xuất' : 'Xác nhận giao TTXM';
    let tenCoQuan = (this.props.dataKiemTraDeXuat && this.props.dataKiemTraDeXuat.donViGiaoKTDX) ? this.props.dataKiemTraDeXuat.donViGiaoKTDX.ten : '';
    return (
      <section className="wrap-block">
        <ShowIf condition={this.state.showAttachFile}>
          <ThongTinYeuCauKiemTraDeXuat khongQuyTrinh={this.props.khongQuyTrinh} listTaiLieuVanThuGiaiQuyetDon={this.props.listTaiLieuVanThuGiaiQuyetDon} {...this.state.dataKiemTraDeXuat} hideTable={true} donInfo={this.props.donInfo}/>
        </ShowIf>
        <div className="wrap-big-line pt5 pb20">
          <span className="big-border"></span>
        </div>
        <h2 className="title-14 mb15">Báo cáo kết quả kiểm tra</h2>
        <form className="form-action">
          <div className="row pl10 pr10">
            <TextArea value={this.state.yKienGiaiQuyet} className="areal-wrap col-100" label="Ý kiến xử lý" placeholder="Nhập ý kiến" onChange={this.onChange.bind(this, 'yKienGiaiQuyet')} name=""/>
            <ShowIf condition={this.state.showAttachFile}>
              <div className="col-100 pb5">
                <ContainerFileDinhKem onSave={this.state.onSave} label="Danh sách văn bản xử lý" bindValidator={this} dataShow={this.state.listTaiLieuVanThuShow} data={this.state.listTaiLieuVanThu} onFileRemove={this.onFileRemove.bind(this)} onFileChange={this.onFileChange.bind(this)}/>
              </div>
            </ShowIf>
          </div>
          <div className="box-bottom">
            <Link className="btn-action btn-close action-todo" role="button" onClick={this.onClickClose.bind(this)}><span>Đóng</span></Link>
            <Link className={this.state.btnLoading ? (this.state.btnSaveLoading ? "btn-action btn-save action-todo btn-loading-inline" : 'btn-action btn-save action-todo btn-disable') : "btn-action btn-save action-todo"} onClick={this.handleSave.bind(this)}><span>Lưu tạm</span></Link>
            <Link style={{right: 0}} className={this.state.btnLoading ? (this.state.btnSaveLoading ? "btn-action btn-move action-todo btn-disable" : 'btn-action btn-move action-todo btn-loading-inline') : "btn-action btn-move action-todo"} onClick={this.openDialog.bind(this)}><span>Gửi báo cáo KTĐX</span></Link>
            <ConfirmDialog open={this.state.openDialog} onClose={this.closeDialog.bind(this)} onSuccess={this.onSuccess.bind(this)} title={lb1} content={'Bạn có đồng ý chuyển cho ' +tenCoQuan + ' báo cáo kiểm tra và để xuất của đơn/vụ việc này không?'}/>
          </div>
        </form>
      </section>
    );
  }
}

CanBoKiemTraDeXuat.defaultProps = {
  validators: {}
}

export default CanBoKiemTraDeXuat;


// WEBPACK FOOTER //
// ./src/components/modules/giai-quyet-don/subView/CanBoKiemTraDeXuat.jsx